export default __webpack_public_path__ + "static/media/stopwatch-green.5173fa0e.svg";